export const FIRST_BANNER_TOP_SALE = {
    testName: 'first_banner_top_sale',
    variants: {
        on: 'fbts_show',
        off: 'fbts_hide',
    },
};

export const REDESIGN_MENU_UNAUTH = {
    testName: 'redesign_menu_unauth',
    variants: {
        on: 'new_menu_unauth',
        off: 'old_menu_unauth',
    },
};
